<template>
    <div class="reminder-form">
        <form @submit.prevent="store" class="reminder-form-container">
            <h2>{{ reminder ? $t('Редактирование напоминания') : $t('Новое напоминание') }}</h2>

            <div class="form-group">
                <input type="text" :class="{'form-control': true, 'is-invalid': hasError('title')}" v-model="form.title" :placeholder="$t('Название')">
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('title')">{{ getError('title') }}</span>

            <div class="form-group">
                <multiselect v-model="form.category" :options="categories" :placeholder="$t('Категория')" label="name" track-by="id" class="form-control">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.name }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                    <template slot="placeholder" slot-scope="props">
                        <div class="placeholder">
                            <span>{{ $t('Категория') }}</span>
                        </div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('category')">{{ getError('category') }}</span>

            <div class="reminder-amount-input-group">
                <input type="text" 
                    :class="{'form-control reminder-amount': true, 'is-invalid': hasError('amount')}" 
                    :value="form.amount != null ? form.amount / 100 : null"
                    @input="form.amount = parseInt($event.target.value * 100)"
                    placeholder="0">
                
                <multiselect v-model="form.currency" :searchable="false" :allow-empty="false" :options="currencies" :placeholder="null" label="symbol" track-by="id" class="form-control reminder-amount-currency">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.symbol }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div></div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('amount')">{{ getError('amount') }}</span>

            <div class="reminder-complete-btn" v-if="form.status != STATUS_COMPLETED && reminder">
                <button class="btn btn-blue w-100" @click="completeReminder">{{ $t('Выполнено') }}</button>

                <div class="reminder-tip" v-if="form.account">
                    <small class="text-muted">
                        {{ $t('transaction_reminder_notice') }} <b>{{ form.account.title }}</b>
                    </small>
                </div>
            </div>

            <div class="datepicker-group reminder-datepicker-group">
                <label>{{ $t('Дата следующего напоминания') }}:</label>
                <date-picker v-model="form.time" :config="datePickerOptions" :class="{'is-invalid': hasError('time')}"></date-picker>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('time')">{{ getError('time') }}</span>

            <div class="form-group">
                <label>{{ $t('Период напоминания') }}:</label>

                <multiselect v-model="form.period" :searchable="false" :allow-empty="false" :options="periods" :placeholder="$t('Период напоминания')" label="name" track-by="key" class="form-control">
                    <template slot="singleLabel" class="signle-lable" slot-scope="props">
                        <div class="label">
                            <span>{{ props.option.name }}</span>
                        </div>
                    </template>
                    <template slot="caret">
                        <div class="caret">
                            <i class="icon icon-chevron-down"></i>
                        </div>
                    </template>
                </multiselect>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('period')">{{ getError('period') }}</span>

            <div class="form-group">
                <textarea :class="{'form-control': true, 'is-invalid': hasError('comment')}" v-model="form.comment" :placeholder="$t('Комментарий / Заметка (не обязательно)')" rows="3"></textarea>
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('comment')">{{ getError('comment') }}</span>

            <div class="auto-detect-controls" v-if="form.category != null">
                <div class="checkbox-group">
                    <input id="auto-detect-check" v-model="form.auto_detect" type="checkbox">
                    <label for="auto-detect-check" class="checkbox-label">
                        {{ $t('Автоматически определять оплату') }}?
                    </label>
                </div>

                <small class="reminder-tip">{{ $t('auto_detect_notice') }}</small>
            </div>

            <div class="btn-group mt-5">
                <button type="button" v-if="reminder" @click="deleteReminder" class="btn btn-light">{{ $t('Delete') }}</button>

                <button type="submit" class="btn btn-form btn-blue">{{ reminder ? $t('Сохранить') : $t('Добавить') }}</button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { EventBus } from '../../../event-bus';
import datePicker from 'vue-bootstrap-datetimepicker';

export default {
    name: "ReminderForm",

    components: {
        datePicker
    },

    props: ['isSideForm', 'reminder'],

	data: function() {
        return {
            form: {
                title: null,
                category: null,
                time: null,
                period: {name: 'Не повторять', key: "never"},
                comment: null,
                auto_detect: false,
                amount: null,
                currency: {id: 0, title: "UAH"},
            },

            periods: [
                {name: 'Раз в неделю', key: "weekly"},
                {name: 'Раз в 4 недели', key: "4weeks"},
                {name: 'Раз в месяц', key: "monthly"},
                {name: 'Не повторять', key: "never"},
            ],

            datePickerOptions: {
                format: 'DD.MM.YYYY',
                useCurrent: true,
                inline: true,
                minDate: new Date(),

                icons: {
                    previous: 'icon icon-chevron-left',
                    next: 'icon icon-chevron-right',
                }
            },

            errors: {},

            STATUS_PLANNED: 0,
            STATUS_WAITING: 1,
            STATUS_COMPLETED: 2,
            STATUS_CANCELED: 3,
        };
    },

    mounted() {
        this.loadCategories();

        this.form.currency = this.currency;


        if(this.reminder) {
            this.form = Object.assign({}, this.reminder);

            let period = this.periods.filter((period) => period.key == this.reminder.period)[0];

            this.form.period = period ? period : {name: 'Не повторять', key: "never"};

            this.form.currency = this.reminder.currency ? this.reminder.currency : {id: 0, title: "UAH"};
        }
    },

    watch: {
        'form.title': function() {
            delete this.errors['title'];
        },
        'form.category': function() {
            delete this.errors['category'];
        },
        'form.currency': function() {
            delete this.errors['currency'];
        },
        'form.amount': function() {
            delete this.errors['amount'];
        },
        'form.time': function() {
            delete this.errors['time'];
        },
        'form.period': function() {
            delete this.errors['period'];
        },
        'form.comment': function() {
            delete this.errors['comment'];
        },
    },

    computed: {
        ...mapGetters(['categories', 'currencies', 'currency']),

        filteredCategories: function() {
            if(this.categories) {
                return this.categories.filter((category) => {
                    return category.expenses;
                });
            }

            return [];
        },
    },

    methods: {
        ...mapActions(['loadCategories', 'loadReminders']),

        store() {
            if(this.reminder) {
                return this.save();
            }

            axios.post('/reminders', this.form)
                .then(({data}) => {
                    this.closeReminderForm();
                    this.loadReminders();

                    this.form = {
                        title: null,
                        category: null,
                        time: null,
                        period: {name: 'Не повторять', key: "never"},
                        comment: null,
                        auto_detect: false,
                        amount: null,
                        currency: {id: 0, title: "UAH"},
                    };

                    EventBus.$emit('reminders-update-amount');

                    return EventBus.$emit('show-alert', data.message ? data.message : $t('Напоминание успешно создано'), 'success'); 
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        save() {
            axios.post(`/reminders/${this.reminder.id}`, this.form)
                .then(({data}) => {
                    this.closeReminderForm();
                    this.loadReminders();

                    EventBus.$emit('reminders-update-amount');
                    
                    return EventBus.$emit('show-alert', data.message ? data.message : $t('Изменения сохранены'), 'success'); 
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        completeReminder() {
            axios.post(`/reminders/${this.reminder.id}/complete`)
                .then(({data}) => {
                    this.closeReminderForm();
                    this.loadReminders();

                    return EventBus.$emit('show-alert', data.message ? data.message : $t('Изменения сохранены'), 'success'); 
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        deleteReminder() {
            axios.delete(`/reminders/${this.reminder.id}`)
                .then(({data}) => {
                    this.closeReminderForm();
                    this.loadReminders();

                    return EventBus.$emit('show-alert', data.message ? data.message : $t('Напоминание удалено'), 'success'); 
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        closeReminderForm() {
            EventBus.$emit('close-side-form');
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    }
}
</script>

<style scoped lang="scss">
.reminder-form {
    .reminder-form-container {
        background: #fff;
        width: calc(100% - 64px);
        border-radius: 5px;
        margin-bottom: 24px;
        padding: 24px 32px;

        @media (max-width: 768px) {
            background: transparent;
            padding: 0 24px;
            width: calc(100% - 48px);
            display: flex;
            flex-direction: column;
            height: 100%;

            .btn-form {
                margin-top: auto;
                margin-bottom: 24px;
            }
        }

        h2 {
            color: #152640;
            font-family: "Proxima Nova Lt";
            font-weight: 600;
            font-size: 18px;
            margin: 0;
            margin-bottom: 24px;
        }

        .auto-detect-controls {
            margin-top: 8px;
            margin-bottom: 10px;
        }

        .reminder-tip {
            font-size: 12px;
            opacity: 0.5;
        }

        input.form-control {
            width: calc(100% - 24px);
        }

        .reminder-amount-input-group {
            display: flex;
            align-items: center;

            .reminder-amount-currency {
                width: 15%;
                margin-left: 12px;
            }
        }

        .reminder-complete-btn {
            margin-top: 10px;

            .reminder-tip {
                margin-top: 5px;
            }
        }
    }
}
</style>